<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
<div class="d-flex align-items-center">
  <el-form inline ref="form" :model="searchform">
     <el-button type="primary" size="mini" @click="delac_up_all" :loading = "delacLoad">{{$t('searchText.선택승인')}}</el-button>  
  <!--  <el-button type="danger" size="mini" @click="deleteAll" class="ml-0">{{$t('searchText.선택삭제')}}</el-button>-->  
    
      <el-form-item class="mb-0 mr-0">

        <el-form-item  class="mb-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                 :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd">
                </el-date-picker>
          </el-form-item>
         
             <el-select v-model="searchform.value" :placeholder="$t('status.선택')" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
          <el-form-item class="mb-0 mr-0">
             <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px" ></el-input>
          </el-form-item>
           <el-form-item class="mb-0 mr-0">
            <el-button type="info" size="mini" @click="sEvent">{{$t('searchText.검색')}}</el-button>
            
          </el-form-item>
  </el-form>
</div>
 
  <el-table
      :data="tableData"
      
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')" @selection-change="handleSelectionChange">
          <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
        <el-table-column
          label="ID"
          type="index"
          align="center"
          width="50">
        </el-table-column>
     <el-table-column
        align="center" v-if="this.sitetype==4 && this.aid=='admin'" :label="$t('tableText.알본사')" prop="admin_id">
      </el-table-column>

      
        <el-table-column
        :label="$t('tableText.시간')"  prop="add_time" align="center">
        
      </el-table-column> 
        

      <el-table-column
        label="admin_id"  prop="admin_id" v-if="this.userid=='admin'" align="center">
        
      </el-table-column> 

      <el-table-column
        label="keys"  prop="keys" align="center">
        
      </el-table-column> 

        <el-table-column
        label="value"  prop="value" align="center">
          <template slot-scope="scope" >
            <span>{{valueTitle[scope.row.value]}}</span>
          </template>
      </el-table-column> 

       <el-table-column
        label="action"  prop="action" align="center">
        
      </el-table-column> 


      <el-table-column
        :label="$t('tableText.수정')"  align="center">
         <template slot-scope="scope" >
           <el-button-group  v-if="scope.row.status == '0'">
             <el-button type="primary"  @click="update(scope.row.id,3)" :loading="btnLoad" size="mini">승인</el-button>
              <el-button type="danger"  @click="update(scope.row.id,-4)" :loading="btnLoad" size="mini">취소</el-button>
            </el-button-group>

            <span v-if="scope.row.status != '0'">{{statusTitle[scope.row.status]}}</span>
          </template>

      </el-table-column>

      <el-table-column
        :label="$t('tableText.상태')" v-if="this.userid!='admin'" align="center">
         <template slot-scope="scope" >
          

            <span>{{statusTitle[scope.row.status]}}</span>
          </template>

      </el-table-column>


      </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
       
        
          
        
        
         
				
</div>
 </template>

 <script>
 import layer from '../../components/common/layer.vue';
import shopDialog from '../../components/common/shop-dialog.vue';
import zpDialog from '../../components/common/zp-dialog.vue';
import layoutLayer from '../../components/common/layout-layer.vue';
import layerNew from '../../components/common/layer-new.vue';

    export default {
     
     components: {
      zpDialog,
      shopDialog,
      layer,
      layerNew,
      layoutLayer
    },

    	data(){
    		return{
          delacLoad:false,
         btnLoad:false,

          dialogModel:false,
            layoutform:{
            mem_id:'',
            money:'',
            memo:'',
          },
          gubun:'1',
           options1: [{
               
                 label: this.$i18n.t("msg.게임머니"),
                 value: '1',
               
              }, {
                label: this.$i18n.t("msg.이벤트머니"),
                 value: '2',
               
              }],
          bonModel:false,
           io_type:'',
           ioType: [
               {
                label: this.$i18n.t("msg.충전"),
                 value: '1',
               
              }, {
                label: this.$i18n.t("msg.환전"),
                 value: '2',
               
              }],
          dWidth:'400px',
          layLoading:false,
           bonForm:{
            mem_id:'',
            money:'',
            memo:'',
          },
          layoutWidth1:'700px',
          zpWidth:'1200px',
          searchform:{
            time:[],
            keyword:'',
            searchOptions:[
             
             {
              label:this.$i18n.t("nav.아이디"),
              value:'mem_id'
            },
               
           
            {
              label:this.$i18n.t("msg.닉네임"),
              value:'mem_name'
            }
            
            ,
            {
              label:this.$i18n.t("msg.알본"),
              value:'admin_id'
            } 
            ],
           
            value:'',
          },
             pickerOptions: {
          },
            shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
          
          bubonModel:false,
          bubonData:[],

          bubonWidth:'1000px',
          valueTitle:{
            'mem_id':this.$i18n.t("msg.회원"),
            'a_code':this.$i18n.t("msg.총판"),
            'b_code':this.$i18n.t("msg.부본"),
            'c_code':this.$i18n.t("msg.매장"),
            's_code':this.$i18n.t("msg.본사"),
          },
          statusTitle:{
            '0':this.$i18n.t("msg.대기"),
            '-4':this.$i18n.t("msg.취소"),
             '3':this.$i18n.t("msg.완료"),
          },
         level_title:{
              '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")            
            },
          bubontop:false,
          domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
          bg:window.sessionStorage.getItem('bg'),
          power:window.sessionStorage.getItem('power'),
          rosing:window.sessionStorage.getItem('rosing'),
          userid:window.sessionStorage.getItem('userid'),
          aid:window.sessionStorage.getItem('admin_id'),
          formLoading:false,
          idDialogVisible: false,
          data:[],

          bubonlist:[{
                label:this.$i18n.t("status.선택"),
              value:''
            }
            
            ],
             adminlist:[{
                label:this.$i18n.t("status.선택"),
                value:''
            },
            
            ],
             bubonOptlist:[{
                label:this.$i18n.t("msg.정상"),
                value:'1'
            },
            {
                label:this.$i18n.t("msg.차단"),
                value:'0'
            }
            
            ],
          tableLoading:false,
          dialogVisible: false,
          dialogTitle: this.$i18n.t("title.소속총판"), // 标题
          editIndex:-1,
          creatModel:false,
          statusOptions:[
             {
              label:this.$i18n.t("msg.정상"),
              value:'1'
            },
             {
              label:this.$i18n.t("msg.차단"),
              value:'0'
            },
            {
              label:this.$i18n.t("status.선택"),
              value:''
            },

            ],
    		  form:{

            pc_e:'',
            pc_slot:'',
            recy:'1',
           admin_id:'',
            agent_name:'',
            regcode:'',
            mem_pw:'',
            mem_name:'',
            mem_id:'',
             id:'',
             boss:'',
            event_loing_recom:'0',
            event_loing_recom_s:'0',
            event_loing_group_recom:'0',
            event_loing_group_recom_s:'0',

             event_loing_recom1:'0',
            event_loing_recom_s1:'0',
            event_loing_group_recom1:'0',
            event_loing_group_recom_s1:'0',

            event_loing_recom_e:'',
            event_loing_recom_slot:'',
            mem_banknum:'',
            mem_bankcode:'',
            mem_bankname:'',
            mem_jumin:'',
            mem_hp:'',
            
            status:'1',
          },
          optvalue:[
           {
              label:'1',
              value:'1'
            },
             {
              label:'2',
              value:'2'
            },
             {
              label:'3',
              value:'3'
            },


          ],
       
          valuenum:'1',
    	
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 tableData: [],
			       currentPage:1,
			       rules: {
                  mem_jumin:[{ required: true, message: '', trigger: 'blur'}],
                 //  recy:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom_s:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group_recom:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group_recom_s:[{ required: true, message: '', trigger: 'blur'}],
                  pc_slot:[{ required: true, message: '', trigger: 'blur'}],
                  pc_e:[{ required: true, message: '', trigger: 'blur'}],
                 // admin_id:[{ required: true, message: '', trigger: 'blur'}],

                  event_loing_recom_e:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom_slot:[{ required: true, message: '', trigger: 'blur'}],
                  agent_name:[{ required: true, message: '', trigger: 'blur'}],
                  mem_bankname:[{ required: true, message: '', trigger: 'blur'}],
                  //regcode:[{ required: true, message: '', trigger: 'blur'}],
                  mem_id:[{ required: true, message: '', trigger: 'blur'}],
                  mem_name:[{ required: true, message: '', trigger: 'blur'}],
                  mem_pw:[{ required: true, message: '', trigger: 'blur'}],
                },
              
			         
			 
    			}
    			
    			
    		},
    		created() {
    			
           this.defaultDate();
    			this.getList();
    			
			
		},
   
    	methods:{
       // i18n 키가 없으면 기본 문구 사용
       tt(key, fallback){
         return this.$te(key) ? this.$t(key) : fallback
       },
       handleSelectionChange(val) {
          console.log(val)
                this.multipleSelection = val;

      },
        defaultDate() {
                  var date = new Date()
                  var year = date.getFullYear().toString()
                  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
                  var da = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
                  // var da = new Date(date.getFullYear(), month, 0).getDate()
                  da < 10 ? '0' + da.toString() : da.toString()
                  var beg = year + '-' + month + '-01'
                  var end = year + '-' + month + '-' + da
                  this.searchform.time = [beg, end] 
                },
       deleteAll(){
        this.$confirm(this.$i18n.t("msg.삭제하시겠습니까복구불가"), this.$i18n.t("msg.알림"), {
         confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            console.log('id',item.id);
            newids.push(item.id);
           });

           console.log('newids',newids);

          this.$axios({
                      method:'post',
                       data:{idx:newids,opt:this.otp},
                      url:this.domain+'/admin/delac_del',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      },
      delac_up_all(){
       
        this.$prompt(this.tt("msg.선택승인하시겠습니까", "선택승인하시겠습니까?"), this.$i18n.t("msg.알림"), {
         confirmButtonText: this.tt("msg.승인", "승인"),
          cancelButtonText: this.tt("msg.닫기", "닫기"),
          inputPlaceholder:this.$i18n.t("newAdd.인증번호"),
          type: 'info'
        }).then(({ value }) => {
          let token=window.sessionStorage.getItem('user');

          console.log(value)

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
           
            newids.push(item.id);
           });
         
           this.delacLoad = true
          
          this.$axios({
                      method:'post',
                       data:{
                        idx:newids,
                        opt:this.otp,
                        code:value,
                      },
                      url:this.domain+'/admin/delac_up_all',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                    this.delacLoad = false
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          }).catch(() => {
            this.delacLoad = false
               
        });

        
      },
         // 删除
      update(id,e){
        // e == 3 : 승인, e == -4 : 취소
        const isApprove = String(e) === '3'
        const confirmMsg = isApprove
          ? this.tt("msg.승인하시겠습니까", "승인하시겠습니까?")
          : this.tt("msg.취소하시겠습니까", "취소하시겠습니까?")

        this.$prompt(confirmMsg, this.$i18n.t("msg.알림"), {
          confirmButtonText: isApprove ? this.tt("msg.승인", "승인") : this.tt("msg.확인", "확인"),
          cancelButtonText: this.tt("msg.닫기", "닫기"),
          inputPlaceholder:this.$i18n.t("newAdd.인증번호"),
          type: isApprove ? 'info' : 'warning'
        }).then(({ value }) => {
          let token=window.sessionStorage.getItem('user');
   
          this.btnLoad=true;
          this.$axios({
                      method:'post',
                      url:this.domain+'/admin/delac_up?id='+id+'&status='+e+'&code='+value,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                    this.btnLoad=false;
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                     this.loading = false
                    
                    this.getList()
    
                  }).catch((error) =>{
                      this.btnLoad=false;
                  })
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t("msg.취소됨")
          });          
        });

        
      },  
          searchEvent(){

          this.openNew();
          this.currentPage=1;
             

        },
        sEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                  this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                   return;
                }

          this.getList();
          
             

        },
          // 关闭弹框（头部的X）
            handleClose () {
               this.dialogVisible = false
            },
        cancelData(){
          this.dialogVisible = false
        },
        hideModel(){
          this.bubonModel = false
        },
        confirm(){

        },

        handleClose1 () {
               this.idDialogVisible = false
            },
        cancelData1(){
          this.idDialogVisible = false
        },
         openIdModel(id){

          if(this.aid=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: '',
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                area: ['950px', '680px'],
             
             });
              return;
           }
           
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['830px', '680px'],
           
        });
        
        },
         openAgentModel(id){
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: shopDialog,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            success: function(layero, index) {
              //对加载后的iframe进行宽高度自适应
                layer.iframeAuto(index);
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['1100px'],
           
        });
        
        },
        openSum(id){
            this.$layer.iframe({
            type: 2,
            title: this.$i18n.t("title.소속총판"),
            content: {
                content: zpDialog,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['1000px', '700px'],
           
        });
        },
   

        openModel(e = false){
          let token=window.sessionStorage.getItem('user');

          this.$axios({
                  method:'get',
                  url:this.domain+'/admin/mstlist_select?type=bossnull&admin=1',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
           let newids=[];

            let obj={};
            obj.label= this.$i18n.t("msg.없음")
            obj.value=''
            newids.push(obj); 

           response.data.data.forEach(item=>{
            let obj={};
            obj.label=item.code
            obj.value=item.code
            newids.push(obj);            
           });

           this.bubonlist=newids


            newids=[];

            


            response.data.admin.forEach(item=>{
            let obj={};
            obj.label=item.name
            obj.value=item.name
            newids.push(obj);            
           });


           

           this.adminlist=newids
    
            }).catch((error) =>{
              
            })


          if(!e){
            this.form = {
                  recy:'1',

                  agent_name:'',
                  regcode:'',
                  pc_slot:'',
                  pc_e:'',
                  mem_pw:'',
                  mem_name:'',
                  mem_id:'',
                  event_loing_group_recom_s:'0',
                  event_loing_group_recom:'0',
                  event_loing_recom:'0',
                  event_loing_recom_s:'0',

                  event_loing_group_recom_s1:'0',
                  event_loing_group_recom1:'0',
                  event_loing_recom1:'0',
                  event_loing_recom_s1:'0',


                  event_loing_recom_e:'',
                  event_loing_recom_slot:'',
                  mem_banknum:'',
                  mem_bankcode:'',
                  mem_bankname:'',
                  mem_jumin:'',
                  mem_hp:'',
                  status:'1',

                 }
             this.editIndex = -1

          }
          else{
            //修改
            this.loading = true
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/bon?id='+e.row.idx,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
                  this.loading = false
                  let item = response.data.data

                  if(response.data.rb>0)
                  {
                     this.bubontop=true;
                  }else
                  {
                     this.bubontop=false;
                  }
                  
                    this.form = {

                          agent_name:item.agent_name,
                          regcode:item.regcode,
                          mem_pw:item.mem_pw,
                          mem_name:item.mem_name,
                          id:item.idx,
                          boss:item.boss,
                           admin_id:item.admin_id,
                          mem_id:item.mem_id,
                          event_loing_recom:item.event_loing_recom,
                          event_loing_recom_s:item.event_loing_recom_s,
                          event_loing_group_recom:item.event_loing_group_recom,
                          event_loing_group_recom_s:item.event_loing_group_recom_s,


                          event_loing_recom1:item.event_loing_recom1,
                          event_loing_recom_s1:item.event_loing_recom_s1,
                          event_loing_group_recom1:item.event_loing_group_recom1,
                          event_loing_group_recom_s1:item.event_loing_group_recom_s1,

                          event_loing_recom_e:item.event_loing_recom_e,
                          event_loing_recom_slot:item.event_loing_recom_slot,
                          mem_banknum:item.mem_banknum,
                          mem_bankcode:item.mem_bankcode,
                          mem_bankname:item.mem_bankname,
                          mem_jumin:item.mem_jumin,
                          mem_hp:item.mem_hp,
                          
                           
                          status:item.status,
                          pc_slot:item.pc_slot,
                          pc_e:item.pc_e,
                          recy:item.recy
                         

                }
                this.editIndex = e.$index
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
          }
          this.creatModel = true
        },
         
    		 submit(){
              let token=window.sessionStorage.getItem('user');
              this.$refs.form.validate((e)=>{
             if(!e) return;
          
             //添加提交
              if (this.editIndex === -1) {
                 this.loading =true
               this.$axios({
                        method:'post',
                        url:this.domain+'/admin/bon_insert',
                        data:{
                         agent_name:this.form.agent_name,
                          regcode:this.form.regcode,
                          boss:this.form.boss,
                          mem_pw:this.form.mem_pw,
                          mem_name:this.form.mem_name,
                          
                          mem_id:this.form.mem_id,

                           admin_id:this.form.admin_id,

                          event_loing_recom:this.form.event_loing_recom,
                          event_loing_recom_s:this.form.event_loing_recom_s,
                          event_loing_group_recom:this.form.event_loing_group_recom,
                          event_loing_group_recom_s:this.form.event_loing_group_recom_s,

                          event_loing_recom1:this.form.event_loing_recom1,
                          event_loing_recom_s1:this.form.event_loing_recom_s1,
                          event_loing_group_recom1:this.form.event_loing_group_recom1,
                          event_loing_group_recom_s1:this.form.event_loing_group_recom_s1,


                          event_loing_recom_e:this.form.event_loing_recom_e,
                          event_loing_recom_slot:this.form.event_loing_recom_slot,
                          mem_banknum:this.form.mem_banknum,
                          mem_bankcode:this.form.mem_bankcode,
                          mem_bankname:this.form.mem_bankname,
                          mem_jumin:this.form.mem_jumin,
                          mem_hp:this.form.mem_hp,
                        
                          status:this.form.status,
                          recy:this.form.recy,
                          pc_slot:this.form.pc_slot,
                          pc_e:this.form.pc_e
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message.success(this.$i18n.t("msg.완료"));
                               //console.log(this.form);
                               this.getList();
                               //this.tableData.unshift(this.form)
                               //关闭
                               this.creatModel = false

                            }
                           this.loading =false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                       this.loading =false
                  })
              
            }else{
              
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/bon_up',
                      data:{
                          agent_name:this.form.agent_name,
                          regcode:this.form.regcode,
                          boss:this.form.boss,
                          mem_pw:this.form.mem_pw,
                          mem_name:this.form.mem_name,
                          id:this.form.id,
                          mem_id:this.form.mem_id,
                          event_loing_recom:this.form.event_loing_recom,
                          event_loing_recom_s:this.form.event_loing_recom_s,
                          event_loing_group_recom:this.form.event_loing_group_recom,
                          event_loing_group_recom_s:this.form.event_loing_group_recom_s,

                           event_loing_recom1:this.form.event_loing_recom1,
                          event_loing_recom_s1:this.form.event_loing_recom_s1,
                          event_loing_group_recom1:this.form.event_loing_group_recom1,
                          event_loing_group_recom_s1:this.form.event_loing_group_recom_s1,




                           event_loing_recom_e:this.form.event_loing_recom_e,
                          event_loing_recom_slot:this.form.event_loing_recom_slot,
                           mem_banknum:this.form.mem_banknum,
                          mem_bankcode:this.form.mem_bankcode,
                          mem_bankname:this.form.mem_bankname,
                          mem_jumin:this.form.mem_jumin,
                          mem_hp:this.form.mem_hp,
                         
                          status:this.form.status,
                           recy:this.form.recy,
                          pc_slot:this.form.pc_slot,
                          pc_e:this.form.pc_e
                         
                        },   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                   if(response.data.code==200){
                       this.creatModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })  
                      this.getList() 
                    }else
                    {
                        // this.creatModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })

            }
            })
              
            
        },
		
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			    
       
    		getList(){

              
    			this.loading = true

          let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }
               

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/delaclist?s_time='+s_time+'&e_time='+e_time+'&page='+this.currentPage+'&'+this.searchform.value+'='+this.searchform.keyword;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                    console.log('tableData=',response.data.data)
                     let data = response.data.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     
                     this.loading =false
               
            }).catch((error) =>{
            	
               this.$message.error(error);
              this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
        
    	openNew(e){

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

           this.bubonModel = true
           let token=window.sessionStorage.getItem('user');
            //console.log(token);
           let urls=this.domain+'/admin/apibet_id?mem_id='+e.row.mem_id+'&s_time='+s_time+'&e_time='+e_time;

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                    console.log('tableData=',response.data.data)
                     let data = response.data
                     this.bubonData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     
                    
               
            }).catch((error) =>{
              
               this.$message.error(error);
              this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
        },
         bonOpen(e,id,type){
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layoutLayer,
                parent: this,
                data:{
                einfo:{e:e},
                info:{id:id,type:type},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['500px', '480px'],
        });
        
        },
   
    		
        
        
    	}
  }
</script>

 <style scoped>

/deep/ .el-dialog__footer {
  padding:0px 20px 20px;
}


/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px;

 }
 >>>.formItem2 label.el-form-item__label{
    color: #444 !important;
    text-align: left;
    padding-left: 5px;
    line-height: 36px;

 }

</style>


// WEBPACK FOOTER //
// src/views/delac/list.vue